const profileTranslations = {
  en: {
    pageTitle: "Profile",
    heroTitle: "Profile",
    heroDesc: "Your personal information",
    name: "Name",
    email: "Email",
    level: "Level",
    enrolledSince: "Enrolled Since",
    enrollmentDetails: "Enrollment Details",
    phone: "Phone",
    batchAllocated: "Batch Allocated",
    feePlan: "Fee Plan",
    completedLevels: "Completed Levels",
    currentLevel: "Current Level",
    notSpecified: "Not specified",
    notAllocated: "Not allocated",
    changePassword: "Change Password", 
    loading: "Loading...",
    error: "Error",
  },
  pa: {
    pageTitle: "ਪ੍ਰੋਫਾਈਲ",
    heroTitle: "ਪ੍ਰੋਫਾਈਲ",
    heroDesc: "ਤੁਹਾਡੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ",
    name: "ਨਾਮ",
    email: "ਈਮੇਲ",
    level: "ਲੈਵਲ",
    enrolledSince: "ਦਾਖਲਾ ਤੋੰ",
    enrollmentDetails: "ਦਾਖਲਾ ਵੇਰਵੇ",
    phone: "ਫ਼ੋਨ",
    batchAllocated: "ਬੈਚ",
    feePlan: "ਫੀ ਪਲਾਨ",
    completedLevels: "ਪੂਰੇ ਕੀਤੇ ਲੈਵਲ",
    currentLevel: "ਮੌਜੂਦਾ ਲੈਵਲ",
    notSpecified: "ਨਿਰਧਾਰਤ ਨਹੀਂ",
    notAllocated: "ਵੰਡਿਆ ਨਹੀਂ",
    changePassword: "ਪਾਸਵਰਡ ਬਦਲੋ", 
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    error: "ਗਲਤੀ",
  },
};

export default profileTranslations;
